import { useConvexMutation } from "@convex-dev/react-query";
import { useMutation } from "@tanstack/react-query";
import { VortexOrganizationProfile } from "@vortexnyc/vortex-core/auth/react";
import { toast } from "sonner";

import { organizationsUpdateBusinessInformation } from "~/api-refs";
import { orgProfileClassNames } from "~/integrations/vortex-auth/class-names";
import { useActiveOrganization } from "~/integrations/vortex-auth/hooks";
import { logger } from "~/lib/logger";
import { ProductEvents } from "~/lib/posthog";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";

// F4: Organization profile is rendered by the vortex-auth profile surface. Edit
// happens inline (no separate edit-profile modal route). plasma only stores
// `businessName` for the org name, so `onUpdate.name` maps to
// `updateBusinessInformation({ businessName })`. The `slug`/`status`/`imageUrl`
// fields the component renders are derived read-only values.
export function OrganizationProfile() {
  const { organization, isLoaded } = useActiveOrganization();
  const updateBusinessInformation = useMutation({
    mutationFn: useConvexMutation(organizationsUpdateBusinessInformation),
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Organization Profile</CardTitle>
        <CardDescription>Update your organization information</CardDescription>
      </CardHeader>
      <CardContent>
        <VortexOrganizationProfile
          classNames={orgProfileClassNames}
          isAdmin
          isLoading={!isLoaded}
          onUpdate={async ({ name }) => {
            if (name === undefined) {
              return;
            }
            try {
              await updateBusinessInformation.mutateAsync({
                businessName: name,
              });
              ProductEvents.settingsUpdated("organization");
              toast.success("Organization updated successfully");
            } catch (error) {
              logger.exception("Failed to update organization", error);
              toast.error("Failed to update organization");
            }
          }}
          organization={
            organization
              ? {
                  _id: organization.id,
                  name: organization.name,
                  slug: organization.id,
                  status: "active",
                }
              : null
          }
        />
      </CardContent>
    </Card>
  );
}
